import { formatDate } from '@/utils/datetimes/formatting';
import { Typography, TypographyProps } from '@mui/material';
import moment from 'moment';

export const OneLineDateRangeDisplay = ({
    startDate,
    endDate,
    timezone,
    dateProps,
    formatString,
}: {
    startDate: Date;
    endDate: Date;
    timezone: string;
    dateProps?: TypographyProps;
    formatString?: string;
}) => {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    if (startMoment.isSame(endMoment, 'day')) {
        return (
            <Typography {...dateProps}>
                On {startMoment.format(formatString ?? 'dddd MMM D YYYY')}
            </Typography>
        );
    } else {
        return (
            <Typography {...dateProps}>
                {formatDate({ datetime: startMoment, timezone, formatString })} -{' '}
                {formatDate({ datetime: endMoment, timezone, formatString })}
            </Typography>
        );
    }
};
